import { apiClient } from "./ApiClient";

export const assignCreditsAPI = async (payload) => {
  const response = await apiClient.post("manageusercredits", payload);
  return response.data;
};

export const listCreditsByOrgAPI = async (organization) => {
  const response = await apiClient.post("manageusercredits", {
    action: "listOrgCredits",
    organization,
  });
  return response.data; // { items: [...] }
};

// --- NEW: session start / end helpers ---
export const logSessionStartAPI = async ({ organization, username, login_ts, user_agent }) => {
  const res = await apiClient.post("manageusercredits", {
    action: "logSessionStart",
    organization,
    username,
    login_ts,
    user_agent
  });
  return res?.data ?? res;
};

export const logSessionEndAPI = async ({ organization, username, log_ts, logout_ts }) => {
  const res = await apiClient.post("manageusercredits", {
    action: "logSessionEnd",
    organization,
    username,
    log_ts,
    logout_ts
  });
  return res?.data ?? res;
};

// bulk setter (many rows for one org)
export async function bulkUpdateUserCreditsAPI(payload) {
  const res = await apiClient.post("manageusercredits", payload);
  return res?.data ?? res;
}

export async function updateUserCreditsAPI(payload) {
  const res = await apiClient.post("manageusercredits", payload);
  return res?.data ?? res;
}

// Get a per-user summary
export async function getUserCreditsSummaryAPI(payload) {
  const res = await apiClient.post("manageusercredits", payload);
  return res?.data ?? res;
}